"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadUser = exports.OidcReducer = exports.OidcProvider = exports.UserManager = exports.User = exports.CallbackComponent = void 0;
/* eslint-disable camelcase */
// import axios from "axios";
var oidc_client_1 = require("oidc-client");
Object.defineProperty(exports, "User", { enumerable: true, get: function () { return oidc_client_1.User; } });
Object.defineProperty(exports, "UserManager", { enumerable: true, get: function () { return oidc_client_1.UserManager; } });
var redux_oidc_1 = require("redux-oidc");
Object.defineProperty(exports, "CallbackComponent", { enumerable: true, get: function () { return redux_oidc_1.CallbackComponent; } });
Object.defineProperty(exports, "OidcProvider", { enumerable: true, get: function () { return redux_oidc_1.OidcProvider; } });
Object.defineProperty(exports, "OidcReducer", { enumerable: true, get: function () { return redux_oidc_1.reducer; } });
Object.defineProperty(exports, "loadUser", { enumerable: true, get: function () { return redux_oidc_1.loadUser; } });
var logout_1 = __importDefault(require("../../pages/logout"));
var env_1 = require("../env");
var env = env_1.getEnv({
    OIDC_CLIENT_ID: process.env.REACT_APP_OIDC_CLIENT_ID || 'REACT_APP_OIDC_CLIENT_ID missing',
    OIDC_SCOPE: process.env.REACT_APP_OIDC_SCOPE || '',
    OIDC_CONFIGURATION_URL: process.env.REACT_APP_OIDC_CONFIGURATION_URL || 'REACT_APP_OIDC_CONFIGURATION_URL missing',
    OIDC_RESPONSE_TYPE: process.env.REACT_APP_OIDC_RESPONSE_TYPE || 'REACT_APP_OIDC_RESPONSE_TYPE missing',
    OIDC_RESPONSE_MODE: process.env.REACT_APP_OIDC_RESPONSE_MODE || 'REACT_APP_OIDC_RESPONSE_MODE missing',
    OIDC_AUTOMATIC_SILENT_RENEW: process.env.REACT_APP_OIDC_AUTOMATIC_SILENT_RENEW || 'REACT_APP_OIDC_AUTOMATIC_SILENT_RENEW missing',
    OIDC_FILTER_PROTOCOL_CLAIMS: process.env.REACT_APP_OIDC_FILTER_PROTOCOL_CLAIMS || 'REACT_APP_OIDC_FILTER_PROTOCOL_CLAIMS missing'
});
var clientId = env.OIDC_CLIENT_ID;
var scope = env.OIDC_SCOPE;
var authority = env.OIDC_CONFIGURATION_URL;
var automaticSilentRenew = (env.OIDC_AUTOMATIC_SILENT_RENEW === 'true') ? true : false;
var filterProtocolClaims = (env.OIDC_FILTER_PROTOCOL_CLAIMS === 'true') ? true : false;
var responseType = env.OIDC_RESPONSE_TYPE;
var responseMode = env.OIDC_RESPONSE_MODE || "query";
var userManagerConfig = {
    authority: authority,
    client_id: clientId,
    redirect_uri: window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : '') + "/authentication/callback",
    popup_redirect_uri: window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : '') + "/oauth2-signin-callback.html",
    silent_redirect_uri: window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : '') + "/authentication/silent_callback",
    post_logout_redirect_uri: window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : '') + logout_1.default.routeProps.path,
    popup_post_logout_redirect_uri: window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : '') + logout_1.default.routeProps.path,
    automaticSilentRenew: automaticSilentRenew,
    filterProtocolClaims: filterProtocolClaims,
    loadUserInfo: false,
    scope: scope,
    response_type: responseType,
    response_mode: responseMode,
};
var userManager = redux_oidc_1.createUserManager(userManagerConfig);
exports.default = userManager;
//# sourceMappingURL=index.js.map